import Index from '../pages/index.vue'
import PagesRoutes from '../pages/routes'

const prefix = '/'

export default [
	{ 
		path: `/${prefix}/admin` , component: Index,
		children: PagesRoutes
	},
]